export default {
  Title: 'Bảo trì dữ liệu',
  LabelInfo: 'Lưu ý: Thời gian thực hiện chức năng này phụ thuộc vào độ lớn của dữ liệu, nên có thể kéo dài.',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  FromMonth: 'Từ tháng',
  Year: 'Năm',
  CheckBoxLabel: 'Ghi sổ các chứng từ chưa ghi sổ',
  Execute: 'Thực hiện',
  ConfirmMessage:
    'Hệ thống đã ghi sổ thành công {0} chứng từ, có <b>{1} chứng từ</b> ghi sổ không thành công tại <b>{2}</b>. Bấm "Xem kết quả" để xem thêm.',
  ConfirmTitle: 'Hoàn thành bảo trì dữ liệu',
  CancelMaintain: 'Hủy bảo trì',
  ChangeDbUse: 'Truy cập vào dữ liệu khác',
  Done100P: 'Hoàn thành 100%',
  ViewResult: 'Xem kết quả',
  MaintainSuccessAll: 'Hệ thống đã bảo trì dữ liệu <b>{0}</b> thành công',
  RollbackDb: 'Khôi phục lại dữ liệu',
  BackupDb: 'Sao lưu dữ liệu trước khi bảo trì',
};
